import { render, staticRenderFns } from "./LecturertLectionMenu.vue?vue&type=template&id=1f386b44&"
var script = {}
import style0 from "./LecturertLectionMenu.vue?vue&type=style&index=0&id=1f386b44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports